import React, { Fragment, useEffect, useState } from "react";
import {
  Layout,
  Space,
  Table,
  PageHeader,
  Select,
  Button,
  message,
  Avatar,
  Row,
  Col,
  Card,
  Image,
} from "antd";
import { useHistory, useRouteMatch } from "react-router-dom";
import { useSelector } from "react-redux";
import "./Customers.scss";
import callIcon from "../../../assets/images/phone.svg";
import mailIcon from "../../../assets/images/mail.svg";
import calIcon from "../../../assets/images/cal.svg";
import addressIcon from "../../../assets/images/address.svg";
import profileIcon from "../../../assets/images/profile.svg";
import location from "../../../assets/images/location.svg";
import moment from "moment";
import { CloseOutlined, EditFilled } from "@ant-design/icons";

const { Content } = Layout;
const { Option } = Select;

const CustomerProfile = ({ customer, isDriver, setIsDriverAddView, showEdit }) => {
  const match = useRouteMatch();
  const [viewDetails, setViewDetails] = useState(false);
  const history = useHistory();

  return (
    <div>
      {customer && (
        <div>
          <Row className="profile-row">
            <Col span={8} className="profile-col">
              <div className="img-name-detail">
                <img
                  src={profileIcon}
                  alt="check"
                  style={{ margin: ".5rem" }}
                />
                <div>
                  <div>Name</div>
                  <div className="cust-detail-name-desc">{customer.name}</div>
                </div>
              </div>
            </Col>
            <Col span={8} className="profile-col">
              <div className="ml-3">First Name</div>
              <div className="ml-2 cust-detail-name-desc">
                {customer.name.substring(0, customer.name.indexOf(" "))}{" "}
              </div>
            </Col>
            <Col span={8} className="profile-col">
              <div className="edit_sec">
                <div>
                  <div className="ml-3">Last Name</div>
                  <div className="ml-2 cust-detail-name-desc">
                  {customer.name.substring(customer.name.indexOf(" ") + 1)}
                  </div>
                </div>
              <div>
              {showEdit && <EditFilled 
                style={{ fontSize: '28px', color: 'grey',marginLeft:"5px", cursor: "pointer" }} 
                onClick={()=>setIsDriverAddView(true)}
              />}
              </div>
              </div>

            </Col>
          </Row>

          <Row className="profile-row">
            <Col span={8} className="profile-col">
              <div className="img-name-detail">
                <img src={callIcon} alt="check" style={{ margin: ".5rem" }} />
                <div>
                  <div>Phone Number</div>
                  <div className="cust-detail-name-desc">
                    {customer.phone_number}
                  </div>
                </div>
              </div>
            </Col>
            <Col span={8} className="profile-col">
              <div className="img-name-detail">
                <img src={mailIcon} alt="check" style={{ margin: ".5rem" }} />
                <div>
                  <div>Email</div>
                  <div className="cust-detail-name-desc">{customer.email}</div>
                </div>
              </div>
            </Col>
            <Col span={8} className="profile-col">
              <div className="img-name-detail">
                <img src={calIcon} alt="check" style={{ margin: ".5rem" }} />
                <div>
                  <div>Created Date</div>
                  <div className="cust-detail-name-desc">
                    {" "}
                    {moment(customer?.address?.created_at).format("MM/DD/yyyy")}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          {!viewDetails ?<Row className="profile-row">
            <Col span={8} className="profile-col">
              <div className="img-name-detail">
                <img src={location} alt="check" style={{ margin: ".5rem" }} />
                <div>
                  <div>Address</div>
                  <div className="cust-detail-name-desc cus_link_view" onClick={()=> setViewDetails(true)}>
                    {customer?.address?.name || '-'}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          :
          <Card
            title={
              <div className="cus_card_title">
                <div>
                  <img
                    src={addressIcon}
                    alt="check"
                    style={{ margin: ".2rem" }}
                  />{" "}
                  {isDriver ? "Restaurants assigned" : "Address"}
                </div>
                <div className="close_btn" onClick={()=> setViewDetails(false)}><CloseOutlined /></div>
              </div>
            }
            className="profile-card-address"
          >
            {isDriver ? (
              <Fragment>
                {customer.restaurants?.map((item) => (
                  <div className="rest-name">{item.restaurant_name}</div>
                ))}
              </Fragment>
            ) : (
              <Fragment>
                <Row className="profile-row">
                  <Col span={8} className="profile-col">
                    <div>Street Address</div>
                    <div className="cust-detail-address">
                      {customer?.address?.address_field1}
                    </div>
                  </Col>
                  <Col
                    span={8}
                    className="profile-col"
                    style={{ textAlign: "start" }}
                  >
                    <div>Building no / House / Flat / Apartment</div>
                    <div className="cust-detail-address">
                      {customer?.address?.address_field2}{" "}
                    </div>
                  </Col>
                  <Col span={8} className="profile-col">
                    <div>State / Province</div>
                    <div className="cust-detail-address">
                      {customer?.address?.state_province}
                    </div>
                  </Col>
                </Row>
                <Row className="profile-row">
                  <Col className="profile-col">
                    <div>Zip code/ pin code</div>
                    <div className="cust-detail-address">
                      {customer?.address?.postal_code}
                    </div>
                  </Col>
                </Row>
              </Fragment>
            )}
          </Card>}
        </div>
      )}
    </div>
  );
};

export default CustomerProfile;
